import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  /**
   * Icons can be fonts or SVGs.
   * [Iconography](http://dev-designsystem.anfcorp.com/style/iconography)
   */
  icon: PropTypes.string.isRequired,
  /**
   * Labels the icon for screen readers.
   * Should be an 'aria-label' or 'alt',
   * but it is not shown visually.
   */
  labelText: PropTypes.string,
  /**
   * onError only works when used with
   * image icons, not font glyphs.
   *
   */
  onError: PropTypes.func,
  size: PropTypes.oneOf(['xs', 's', 'm', 'l', 'xl'])
};
function Icon(_ref) {
  var icon = _ref.icon,
    _ref$labelText = _ref.labelText,
    labelText = _ref$labelText === void 0 ? null : _ref$labelText,
    _ref$onError = _ref.onError,
    onError = _ref$onError === void 0 ? null : _ref$onError,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? null : _ref$size;
  var isImage = icon.indexOf('.') >= 0;
  var Element = isImage ? 'img' : 'span';
  return /*#__PURE__*/React__default.createElement(Element, {
    alt: isImage ? labelText : null,
    "aria-label": !isImage ? labelText : null,
    "aria-hidden": !labelText ? true : null,
    className: "icon",
    "data-icon": !isImage ? icon : null,
    "data-icon-size": size,
    "data-testid": !labelText ? 'icon' : null,
    onError: onError,
    role: !isImage && labelText ? 'img' : null,
    src: isImage ? icon : null
  });
}
Icon.propTypes = propTypes;

export { Icon as default };
//# sourceMappingURL=Icon.js.map
